import { Button, Card, DataTable, RadioButton } from '@shopify/polaris';
import React, { useCallback, useEffect, useState } from 'react';

const ListTemplates = ({
  templates,
  setTemplateId,
  templateId,
  selectTemplate,
  setOpenTemplateList,
}: any) => {
  const [rows, setRows] = useState([]);
  const handleChange = (newValue: any) => {
    setTemplateId(newValue);
  };
  useEffect(() => {
    let tempRows: any = [];
    templates?.forEach((template: any) => {
      tempRows.push([
        <RadioButton
          label={template.name}
          helpText=''
          id={template.id}
          name='templates'
          checked={templateId === template.id}
          onChange={() => handleChange(template.id)}
        />,
        <p onClick={() => handleChange(template.id)}>
          {template.internalText}
        </p>,
      ]);
    });
    setRows(tempRows);
  }, [templateId]);

  return (
    <div className='createCampaignButtons'>
      <Card>
        <div
          style={{ height: '300px', overflowY: 'auto', overflowX: 'hidden' }}
        >
          <DataTable
            columnContentTypes={['text', 'text']}
            headings={['Template Name', 'Message']}
            rows={rows}
          />
        </div>
      </Card>{' '}
      <div className='labelMargin' style={{ float: 'right' }}>
        <Button outline primary onClick={() => setOpenTemplateList(false)}>
          Cancel
        </Button>
        <Button
          primary
          onClick={() => {
            selectTemplate(templateId);
            setOpenTemplateList(false);
          }}
        >
          Choose Template
        </Button>
      </div>
    </div>
  );
};
export default ListTemplates;
